// @flow

//
// Lodash
//
import get from 'lodash/get';

//
// React
//
import React from 'react';

//
// Type
//
import {
    type CellRendererFactoryProps,
    type CellProps,
} from '../types/CellProps';

//
// Helper
//
import { renderAsLink } from './tools';

//
// Component
//
const createTextCellRenderer = (cfg: CellRendererFactoryProps): any => (props: CellProps): any => {
    const content = (cfg.dataPath) ? get(props.value, cfg.dataPath, '') : props.value;

    return (
        <div style={{ whiteSpace: 'pre-line' }}>
            {renderAsLink(cfg.onClick, props.row)(content)}
        </div>
    );
};
export default createTextCellRenderer;
